import * as Sentry from "@sentry/astro";

Sentry.init({
  dsn: "https://6763d09cc3544d93a345d6375a40b81d@o310203.ingest.us.sentry.io/1775499",
  debug: false,
  environment: import.meta.env.PUBLIC_VERCEL_ENV,
  release: import.meta.env.PUBLIC_VERCEL_GIT_COMMIT_SHA,
  tracesSampleRate: 1,
  integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1,
});